import { EXPENSE_TYPES } from '@/modules/transactions/_constants/constants'

export default {
  data () {
    return {
      showMediaTypeModalFlag: false,
      receiptUploaded: false,
      typeSelected: false,
      uploadingReceipts: false
    }
  },
  methods: {
    manageReceipts (event) {
      this.receiptUploaded = event
      this.showMediaTypeModal()
    },
    showMediaTypeModal () {
      this.showMediaTypeModalFlag = true
    },
    typeIsSelected (type) {
      this.typeSelected = type
      if (this.transactionId) {
        this.uploadReceipts(this.receiptUploaded, true)
      } else {
        this.setExpenseReceipts(this.receiptUploaded)
      }
    },
    async setExpenseReceipts (event) {
      let receipts = []

      if (event.length && event.length > 0) {
        let receivedFileList = [...event]
        receivedFileList.forEach((el) => {
          let receiptLocalIdAux = this.receiptLocalId++
          receipts.push({
            id: receiptLocalIdAux,
            file: el,
            media: {
              id: receiptLocalIdAux,
              type: this.typeSelected
            }
          })
        })
      }

      this.$store.dispatch('TransactionsStore/addExpensesReceipts', receipts)
      if (this.expenseType === EXPENSE_TYPES.EXPENSE || this.expenseType === EXPENSE_TYPES.REIMBURSEMENT) {
        // this.$emit('createDraft')
         await this.createExpense('DRAFT')
      }
      if (!localStorage.getItem('uploadInProgress')) {
        this.showUploadInProgress = true
      }
    },
    async uploadReceipts (files, uploadByDragAndDrop = false) {
      await this.$store
        .dispatch('TransactionsStore/submitTransactionReceipt', {
          id: this.transactionId,
          type: this.typeSelected,
          files: files,
          dragAndDropUpload: true
        }).then(async () => {
          // this.$emit('uploadedReceipt', files.length)
          await this.uploadedReceipt(files.length)
          this.files = null
          this.uploadingReceipts = false
        })
      if (!localStorage.getItem('uploadInProgress')) {
        this.showUploadInProgress = true
      }
    }
  }

}
